import { User } from './user';

export class Souscription {

    id: number;
    num_titre_foncier: string;
    superficie: number;
    localisation: string;
    num_cert_pro: string;
    num_cert_urb: string;
    description: string;
    comment_description: string;
    projet: string;
    budgetdispo: string;
    financement: string;
    service: string;
    comment_service: string;
    date_souscription: string;
    type_souscription: string;
    payment_status: string;
    create_by: string;
    date_create: string;
    date_modif: string;
    discriminator: string;
    user: User;

    constructor() {}


}
